import { LogLevel } from "@azure/msal-browser";

// Initialize window._env_ if it doesn't exist (fallback for when config.js hasn't loaded)
if (typeof window !== 'undefined' && !window._env_) {
  window._env_ = {};
}

export const msalConfig = {
  auth: {
    //redirectUri: "http://localhost:8000/login",

    //clientId: "58d38cc6-2679-4dca-bb13-8cb1be9955fc", //LOCAL
    //clientId: "2e05a65e-1126-44fe-bfdb-1cadc83bfa16", //WHO
   //authority:
        //"https://login.microsoftonline.com/08d59ab8-c799-4743-b196-6d9cabf28402", //LOCAL
     //  "https://login.microsoftonline.com/f610c0b7-bd24-4b39-810b-3dc280afb590" //WHO

    redirectUri: (window._env_ && window._env_.RTRT_APP_REDIRECT_URI) || "http://localhost:8000/login",
    clientId: (window._env_ && window._env_.RTRT_APP_CLIENT_ID) || "58d38cc6-2679-4dca-bb13-8cb1be9955fc",
    authority: (window._env_ && window._env_.RTRT_APP_AUTHORITY) || "https://login.microsoftonline.com/08d59ab8-c799-4743-b196-6d9cabf28402",
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: true,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

export const loginRequest = {
  scopes: ["User.Read","Group.Read.All"],
  //scopes: ["User.Read"],
};
